import { createStore, withProps } from '@ngneat/elf';

export interface SeuilsStateProps {
  response: any;
  dto: {
    acId: number;
    typeMarcherId: number;
    seuil: number;
  };
  serverState: any;
}

export const seuilsInitialState: SeuilsStateProps = {
  response: null,
  dto: {
    acId: 0,
    typeMarcherId: 0,
    seuil: 0,
  },
  serverState: undefined,
};

export const seuilsStateStore = createStore(
  { name: 'seuils-state' },
  withProps<SeuilsStateProps>({
    ...seuilsInitialState,
  })
);
